import * as actionTypes from '../../constants/actionTypes';

const initialState = {
  cropIssueList: [],
  totalNumberOfCropIssues: null,
  isArchivedCropIssuesLoading: false
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_CROP_ISSUES_SUCCESS:
      if (!action.payload.isActive) {
        return Object.assign({}, {
          cropIssueList: action.payload.cropIssueList,
          totalNumberOfCropIssues: action.payload.totalNumberOfCropIssues
        });
      }
      return state;
    case actionTypes.GET_CROP_ISSUES_ERROR:
      if (action.payload.isActive) {
        return initialState;
      }
      return state;
    case actionTypes.SHOW_LOADER:
      switch (action.payload) {
        case actionTypes.GET_CROP_ISSUES:
          return Object.assign({}, state, {isArchivedCropIssuesLoading: true});
        default:
          return Object.assign({}, state);
      }
    case actionTypes.HIDE_LOADER:
      switch (action.payload) {
        case actionTypes.GET_CROP_ISSUES:
          return Object.assign({}, state, {isArchivedCropIssuesLoading: false});
        default:
          return Object.assign({}, state);
      }
    default:
      return state;
  }
}
